<template>
  <div>
    <div class="boxTop">
      <span style="margin-right: 10px;">批量上传图片:</span>
      <el-upload action="" multiple :limit="5" :http-request="upload" :auto-upload="true" ref="up0" accept=".jpg,.jpeg,.png">
        <div slot="file" style="display: none;" />
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
    </div>
    <div class="box">
      <el-upload action="" :http-request="upload" :auto-upload="true" :limit="1" ref="up1" accept=".mp4,.avi" v-show="!disableVideo">
        <i slot="default" class="el-icon-plus"></i>
        <span>上传视频</span>
        <div slot="file" style="display: none;" />
        <div class="img-show" controls v-if="videoPreviewList[0]" @click.stop>
          <video :src="videoPreviewList[0]" width="140" height="140"></video>
          <div class="edit"><i class="el-icon-delete" style="font-size: 24px; color: #FFFFFF;" @click.stop="deleteItem(-1)"></i></div>
        </div>
      </el-upload>
      <el-upload action="" :http-request="upload" :auto-upload="true" :limit="1" v-for="(item, index) in 5" :key="index" ref="up" accept=".jpg,.jpeg,.png">
        <i slot="default" class="el-icon-plus"></i>
        <span>上传图片</span>
        <div slot="file" style="display: none;" />
        <div class="img-show" v-show="imgPreviewList[index]" @click.stop>
          <el-image :src="imgPreviewList[index]" alt="" fit="cover" />
          <div class="edit"><i class="el-icon-delete" style="font-size: 24px; color: #FFFFFF;" @click.stop="deleteItem(index)"></i></div>
        </div>
      </el-upload>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="medium">取 消</el-button>
      <el-button @click="save" size="medium" class="green-btn">确 定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imgListProp: {
      type: Array,
      default: () => []
    },
    typeProp: {
      type: Number,
      default: 1
    },
    disableVideo: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    imgListProp: {
      handler(nv, ov) {
        this.videoData = nv.filter(item => {
          return item.path.search('mp4') != -1 || item.path.search('.avi') != -1;
        });
        this.imgData = nv.filter(item => {
          return item.path.search('png') != -1 || item.path.search('jpg') != -1 || item.path.search('jpeg') != -1;
        });
        console.log(this.imgPreviewList);
      },
      immediate: true
    },
    typeProp: {
      handler(nv, ov) {
        this.type = nv;
      },
      immediate: true
    }
  },
  computed: {
    videoPreviewList() {
      return this.videoData.map(item => item.path);
    },
    imgPreviewList() {
      return this.imgData.map(item => item.path);
    },
    dataIdList() {
      return [...this.videoData, ...this.imgData];
    }
  },
  data() {
    return {
      type: 1,
      videoData: [],
      imgData: [],
      formData: {},
      up: null
    };
  },
  methods: {
    clearFile(isClear) {
      this.$refs['up0'].clearFiles();
      this.$refs['up1'].clearFiles();
      for (let s of this.$refs['up']) {
        s.clearFiles();
      }
      if (isClear) {
        this.imgData = [];
        this.videoData = [];
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async upload(param) {
      for (let i = 0; i < 500; i++) {
        if (!this.up) {
          this.formData.files = param.file;
          this.up = this.$q.common.uploadMedia({ data: this.formData });
          console.log('成功配置上传”');
          break;
        } else {
          await this.sleep(200);
          console.log('等待中...');
        }
      }
      this.up
        .then(res => {
          if (param.file.type == 'video/mp4') {
            this.videoData = this.videoData.concat(res.data);
          } else {
            if (this.imgData.length >= 5) {
              this.$notify({
                title: '提示',
                message: '最大限制上传5张图片',
                type: 'warning'
              });
              return;
            }
            this.imgData = this.imgData.concat(res.data);
          }
        })
        .catch(error => {})
        .finally(() => {
          this.up = null;
        });
      this.clearFile(false);
    },
    deleteItem(index) {
      if (index == -1) {
        this.videoData.splice(0, 1);
      } else {
        this.imgData.splice(index, 1);
      }
    },
    cancel() {
      this.clearFile(true);
      this.$emit('cancel');
    },
    save() {
      console.log(this.dataIdList);
      this.$emit('save', [...this.dataIdList]);
      this.clearFile(true);
    }
  }
};
</script>

<style lang="stylus" scoped>
.boxTop
  display flex
  justify-content flex-start
  align-items center
  margin-bottom 30px
.box
  display flex
  justify-content center
  align-items center
  & > div
    height 110px
    margin-left 20px
  >>>.el-upload
    height 110px
    width 110px
    box-sizing border-box
    display flex
    justify-content center
    align-items center
    border 1px dashed #ccc
    position relative
.img-show
  position absolute
  top 0
  left 0
  height 110px
  width 110px
  overflow hidden
  .edit
    position absolute
    display none
    top 0
    left 0
    height 110px
    width 110px
    background-color rgba(0, 0, 0, 0.5)
    justify-content center
    align-items center
    overflow hidden
  &:hover .edit
    display flex
.dialog-footer
  display flex
  justify-content center
  align-items center
  margin-top 30px
</style>
